import { Router } from '@angular/router';

/** Current shell: /main, /teacher, or /supervisor. */
export function portalBase(router: Router): string {
  const path = router.url.split('?')[0];
  if (path.startsWith('/teacher')) {
    return '/teacher';
  }
  if (path.startsWith('/supervisor')) {
    return '/supervisor';
  }
  return '/main';
}

export function portalCommands(router: Router, ...segments: Array<string | number>): string[] {
  return [portalBase(router), ...segments.map(segment => String(segment))];
}
